import LocalizedStrings from 'localized-strings';

import countriesList from 'common/countries/countriesList';

/**
 * Build a map of countries codes
 *
 * @example
 * {
 *   en: {
 *     AD: 'Andorra'
 *   },
 *   fr: {
 *     AD: 'Andorre'
 *   }
 * }
 */
const LOCALIZED_COUNTRY_CODES = Object.keys(countriesList).reduce(
  (acc, countryCode) => {
    const country = countriesList[countryCode];
    return {
      en: {
        ...acc.en,
        // @ts-expect-error country is possibly 'undefined'.
        [countryCode]: country.name.en,
      },
      fr: {
        ...acc.fr,
        // @ts-expect-error country is possibly 'undefined'.
        [countryCode]: country.name.fr,
      },
    };
  },
  {
    en: {},
    fr: {},
  },
);

const locales = new LocalizedStrings(LOCALIZED_COUNTRY_CODES);

const getCountryByCode = (countryCode: string): string => {
  return (
    locales.getString(countryCode, locales.getLanguage(), true) || countryCode
  );
};

export default getCountryByCode;
